import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ShoppingCartService } from '../services/shopping-cart.service';
import { CommonService } from '../services';
import { ShoppingCart } from '../models/shopping-cart.model';

@Component({
  selector: 'app-finance-quotes',
  templateUrl: './finance-quotes.component.html',
  styleUrls: ['./finance-quotes.component.css']
})
export class FinanceQuotesComponent implements OnInit, OnDestroy {

  title = 'Finance Quotes';
  loadContent: boolean = false;
  shoppingCarts: ShoppingCart[] = [];
  shoppingCartsFilter: ShoppingCart[] = [];
  searchText: string;

  constructor(
    private shoppingCartService: ShoppingCartService,
    private commonService: CommonService,
    private router: Router
  ) {
    commonService.emitUpdateSideBarActiveItem('financing');
  }

  ngOnInit() {
    this.loadContent = false;
    this.shoppingCartService.getFinancedCartList().subscribe((sc: ShoppingCart[]) => {
      this.loadContent = true;
      if(sc.length > 0){
        this.shoppingCarts = sc;
        this.shoppingCartsFilter = this.shoppingCarts;
      }
    },
      (error: any) => {
        console.error(error);
      });
  }

  filterShoppingCarts(): void{
    this.shoppingCartsFilter = this.shoppingCarts.filter(x => x.cartName.toLowerCase().includes(this.searchText.toLowerCase()));
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }

  ngOnDestroy() {
    this.commonService.emitUpdateSideBarActiveItem('');
  }

}
